import { Component, EventEmitter, Input,  OnInit, Output, HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';

@Component({
  selector: 'app-services-profile',
  templateUrl: './services-profile.component.html',
  styleUrls: ['./services-profile.component.scss']
})
export class ServicesProfileComponent implements OnInit {

  @Input() servicesForm!: FormGroup;
  @Input() endCustomerData: any;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  services: any[] = [];
  filteredServices: any[] = [];
  servicesData: any[] = [];

  showEditForm: boolean = false;
  copyServicesForm: any;

  noRecordsFoundData: boolean = false;
  isServiceInputFieldClicked: boolean = false;

  constructor(private endCustomerService: EndCustomerService) { }

  ngOnInit(): void {
    this.getServices();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const targetElement = event.target as HTMLElement;
    const dropdownElement = document.querySelector('.skillSetDopdownContainer');
    const formFieldElement = document.querySelector('.equipment');

    if (dropdownElement?.contains(targetElement) || formFieldElement?.contains(targetElement)) {
      return;
    }

    this.isServiceInputFieldClicked = false;
  }

  getServices() {
    this.endCustomerService.executeGetRequestURL(MweConstants.allServicesUrl, null).subscribe(data => {
      if (data?.data?.length > 0) {
        this.services = data.data;
        this.filteredServices = this.services;

        if (this.servicesForm.get('serviceInfos')?.value?.length > 0) {
          this.getServicesData();
        }
      }
    });
  }


  filterServices(event: any) {
    this.isServiceInputFieldClicked = true;
    const searchText = event.target.value.toLowerCase();

    this.filteredServices = this.services.filter((service: any) =>
      service.name.toLowerCase().includes(searchText)
    );

    this.noRecordsFoundData = this.filteredServices.length === 0;
  }

  checkBoxClicked(service: any) {
    const serviceControl = this.servicesForm.get('serviceInfos')?.value || [];

    if (serviceControl.includes(service.id)) {
      const updatedServices = serviceControl.filter((id: any) => id !== service.id);
      this.servicesForm.get('serviceInfos')?.patchValue(updatedServices);
    } else {
      serviceControl.push(service.id);
      this.servicesForm.get('serviceInfos')?.patchValue(serviceControl);
    }
  }

  serviceInputFieldClicked() {
    this.isServiceInputFieldClicked = true;
    if (this.filterServices.length === 0) {
      this.noRecordsFoundData = true;
    } else {
      this.noRecordsFoundData = false;
    }
  }

  keyDownButton(service: any, event: any) {
    if (event.key === 'Enter') {
      this.checkBoxClicked(service);
    }
  }

  
  update() {
    this.onUpdate.emit(40);
    this.refresh();
  }

  cancel() {
    this.showEditForm = false;
    this.servicesForm.get('serviceInfos')?.patchValue([]);

    if (this.copyServicesForm?.serviceInfos?.length > 0) {
      this.servicesForm.get('serviceInfos')?.patchValue(this.copyServicesForm.serviceInfos);
    }
    this.getServicesData();
  }

  editService() {
    this.copyServicesForm = JSON.parse(JSON.stringify(this.servicesForm.value));
    this.showEditForm = true;
  }

  refresh() {
    this.showEditForm = false;
    this.getServicesData();
  }

  getServicesData() {
    const services = this.services;
    let serviceInfos: any[] = [];

    if (this.endCustomerData?.serviceInfos?.length > 0) {
      serviceInfos = services.filter((obj1: any) =>
        this.endCustomerData.serviceInfos.some((obj2: any) => obj1.id === obj2.serviceInfoId)
      );
    }
    this.servicesData = serviceInfos;
  }

  remove(i: number): void {
    this.servicesForm.get('serviceInfos')?.value.splice(i, 1);
    this.servicesForm.get('serviceInfos')?.patchValue(this.servicesForm.get('serviceInfos')?.value);
  }

  getService(id: any) {
    return this.services.find((obj: any) => obj?.id === id)?.name;
  }
}
